import Query from '../../components/Report';

const query = ({ offset = 0 }) => new Query('discover-pages', { offset });

export const getAllQuery = () => new Query('discover-pages-all');

export default query;
